import Firebase from "#classes/Firebase"

// TODO: Move this to the server
export const hashPin = async (pin: string) => {
  const encoder = new TextEncoder()
  const data = encoder.encode(pin)
  const hashBuffer = await crypto.subtle.digest("SHA-256", data)
  // Convert to hex string
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("")
}

// Example usage:
// const userId = firebase.auth().currentUser.uid // or your Google UID
// const pin = "1234"

// hashPin(pin, userId).then((pinHash) => {
// Save pinHash to Firestore or Realtime DB
// })

// Unused
export const verifyPin = async (inputPin: string, storedHash: string) => {
  const hash = await hashPin(inputPin)
  return hash === storedHash
}

// Calculate Hamming distance between two PINs (as strings)
export const hammingDistance = (a: string, b: string): number =>
  a.split("").reduce((sum, char, idx) => sum + (char !== b[idx] ? 1 : 0), 0)

// Check if PIN has all same digits (1111, 2222, etc.)
export const hasRepeatedDigits = (pin: string): boolean => {
  return pin.split("").every((digit) => digit === pin[0])
}

// Check if PIN is sequential (1234, 3456, 9876, etc.)
export const isSequential = (pin: string): boolean => {
  const digits = pin.split("").map(Number)

  // Check ascending sequence
  const isAscending = digits.every((digit, index) => {
    if (index === 0) return true
    return digit === digits[index - 1] + 1
  })

  // Check descending sequence
  const isDescending = digits.every((digit, index) => {
    if (index === 0) return true
    return digit === digits[index - 1] - 1
  })

  return isAscending || isDescending
}

// Generate a unique, separated PIN
export const generateUniquePin = async (
  minDistance = 2,
  maxAttempts = 1000
): Promise<string> => {
  const existingPins = await Firebase.getInstance().getUsedPins()

  for (let attempts = 0; attempts < maxAttempts; attempts++) {
    const candidate = Math.floor(1000 + Math.random() * 9000).toString()
    if (
      !existingPins.includes(candidate) &&
      existingPins.every((p) => hammingDistance(candidate, p) >= minDistance) &&
      !hasRepeatedDigits(candidate) &&
      !isSequential(candidate)
    ) {
      return candidate
    }
  }
  throw new Error("Could not generate a unique, separated PIN.")
}

// Assign a new PIN to a user (and save it in both places)
export const assignPinToUser = async (userId: string, pin: string) => {
  await Firebase.getInstance().saveUserPin(userId, pin)
}
